import { CartProductCode, MSSPriceSectionId } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../../../state/state';
import { ManageMembershipPriceCartItem } from '../ManageMembershipPriceCartItem';
import { IconProps } from '@ace-clublabs/shared-component-library';

export const FamilyMemberPriceCartItem = () => {
  const [priceCart] = useGlobalState('priceCart');

  const addedFamilyMembers = priceCart?.items?.filter((m) => {
    const hasAssociateCode =
      m.code === CartProductCode.ADULT || m.code === CartProductCode.DEPENDENT || m.code === CartProductCode.ASSOCIATE;
    return hasAssociateCode && m.price && m.price > 0;
  });
  const displayName = (lineItem: string) => lineItem.split('-')[0]?.trim();
  const displayRole = (lineItem: string) => lineItem.split('-')[1]?.trim();

  const familyCost = priceCart?.items?.find((i) => i.id === MSSPriceSectionId.FAMILY_COST);
  const familyUpgradeFee = familyCost?.price || 0;
  const displayFamilyMembers = (addedFamilyMembers && addedFamilyMembers.length > 0) || familyUpgradeFee > 0;

  const getFamilyMembersList = () => {
    const list = [];
    addedFamilyMembers?.forEach((m) =>
      list.push({
        name: displayName(m.description),
        subtext: displayRole(m.description),
        price: m.price,
      })
    );
    if (familyUpgradeFee > 0)
      list.push({
        name: 'Family upgrade fee',
        price: familyUpgradeFee,
        iconName: 'circle-info-regular' as IconProps['iconName'],
      });
    return list;
  };

  return displayFamilyMembers ? (
    <ManageMembershipPriceCartItem
      type="list"
      subtitle="Family members:"
      className="family-members-price-item"
      list={getFamilyMembersList()}
    />
  ) : (
    <></>
  );
};
